<template>
  <div class="disposal-statistics-container">
    <!-- 标题区域 -->
    <div class="header-section">
      <div class="title">中药房门诊退药</div>
      <div class="sub-title"></div>
    </div>

    <!-- 筛选区域 -->
    <el-card class="filter-section">
      <div class="filter-container">
        <div class="filter-left">
          <!-- 状态筛选下拉菜单 -->
          <div class="filter-item">
            <el-dropdown trigger="hover" placement="bottom-start" @command="handleStateCommand">
              <el-button type="primary" size="mini" class="state-dropdown-btn">
                {{ getStateButtonText() }}<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="''">全部</el-dropdown-item>
                <el-dropdown-item :command="0">草稿</el-dropdown-item>
                <el-dropdown-item :command="1">已收费</el-dropdown-item>
                <el-dropdown-item :command="2">已配药</el-dropdown-item>
                <el-dropdown-item :command="3">已发药</el-dropdown-item>
                <el-dropdown-item :command="4">待退费</el-dropdown-item>
                <el-dropdown-item :command="5">已退药</el-dropdown-item>
                <el-dropdown-item :command="6">已作废</el-dropdown-item>
                <el-dropdown-item :command="7">已退费</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          
          <div class="filter-item">
            <span class="filter-label">处方编号：</span>
            <el-input
              v-model="filters.rxNo"
              placeholder="处方编号/病人姓名"
              size="mini"
              clearable
              style="width: 160px;"
              @keyup.enter.native="handleSearch"
            />
          </div>
          
          <div class="filter-item">
            <span class="filter-label">时间范围：</span>
            <el-date-picker
              v-model="filters.dateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              size="mini"
              style="width: 220px;"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
              class="custom-date-picker"
            />
          </div>
		  
		  <div class="filter-right">
		    <el-button type="primary" size="mini" @click="handleSearch" icon="el-icon-Ssearch">查询</el-button>
		    <el-button type="warning" size="mini" @click="handleReset" icon="el-icon-refresh">重置</el-button>
		    <el-button type="success" size="mini" :disabled="true" @click="handleExport" icon="el-icon-download">导出</el-button>
		  </div>
        </div>
      </div>
    </el-card>

    <!-- 表格区域 -->
    <div class="table-section">
      <div class="table-container">
        <el-table
          :data="tableData"
          border
          stripe
          size="mini"
          :height="tableMaxHeight"
          :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
          v-loading="loading"
          :row-class-name="tableRowClassName"
        >
          <!-- 行号 -->
          <el-table-column
            label="#"
            type="index"
            align="center"
            width="60"
            fixed="left"
          />
          
          <!-- 处方状态 -->
          <el-table-column
            prop="state"
            label="处方状态"
            align="center"
            width="100"
          >
            <template slot-scope="scope">
              <el-tag
                :type="getStatusType(scope.row.state)"
                size="small"
                effect="plain"
              >
                {{ getStatusText(scope.row.state) }}
              </el-tag>
            </template>
          </el-table-column>
          
		  <!-- 处方编号 -->
		  <el-table-column
		    prop="rxNo"
		    label="处方编号"
		    align="left"
		    width="140"
		    show-overflow-tooltip
		  >
		    <template slot-scope="scope">
		      <a 
		        href="javascript:void(0)" 
		        class="patient-name-link" 
		        @click="handleViewDetail(scope.row)"
		      >
		        <strong>{{ scope.row.rxNo }}</strong>
		      </a>
		    </template>
		  </el-table-column>
		  
          <!-- 病人姓名 -->
          <el-table-column
            prop="name"
            label="病人姓名"
            align="left"
            width="100"
            show-overflow-tooltip
          >
          </el-table-column>
          
          <!-- 性别 -->
          <el-table-column
            prop="sex"
            label="性别"
            align="center"
            width="80"
          >
            <template slot-scope="scope">
              <div class="gender-display">
                <i :class="scope.row.sex === 1 ? 'el-icon-male male-icon' : 'el-icon-female female-icon'"></i>
                <span :class="scope.row.sex === 1 ? 'male-text' : 'female-text'">
                  {{ scope.row.sex === 1 ? '男' : '女' }}
                </span>
              </div>
            </template>
          </el-table-column>
          
          <!-- 年龄 -->
          <el-table-column
            prop="age"
            label="年龄"
            align="center"
            width="80"
          >
            <template slot-scope="scope">
              {{ scope.row.age }}岁
            </template>
          </el-table-column>
          
          <!-- 划价方式 -->
          <el-table-column
            prop="pricingType"
            label="划价方式"
            align="center"
            width="100"
          >
            <template slot-scope="scope">
              {{ getPricingTypeText(scope.row.pricingType) }}
            </template>
          </el-table-column>
          
          <!-- 皮试处方 -->
          <el-table-column
            prop="skintstRx"
            label="皮试处方"
            align="center"
            width="80"
          >
            <template slot-scope="scope">
              {{ scope.row.skintstRx === 1 ? '是' : '否' }}
            </template>
          </el-table-column>
          
          <!-- 处方类型 -->
          <el-table-column
            prop="rxName"
            label="处方类型"
            align="center"
            width="100"
            show-overflow-tooltip
          />
          
          <!-- 处方科室 -->
          <el-table-column
            prop="bilgDeptName"
            label="处方科室"
            align="center"
            width="120"
            show-overflow-tooltip
          />
          
          <!-- 处方医生 -->
          <el-table-column
            prop="bilgDrName"
            label="处方医生"
            align="center"
            width="120"
            show-overflow-tooltip
          />
          
          <!-- 处方金额 -->
          <el-table-column
            prop="saleAmt"
            label="处方金额(元)"
            align="center"
            width="120"
          >
            <template slot-scope="scope">
              {{ formatCurrency(scope.row.saleAmt) }}
            </template>
          </el-table-column>
          
          <!-- 划价人 -->
          <el-table-column
            prop="bilgOptName"
            label="划价人"
            align="center"
            width="100"
            show-overflow-tooltip
          />
          
          <!-- 划价时间 -->
          <el-table-column
            prop="bilgDate"
            label="划价时间"
            align="center"
            width="150"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ formatDateTime(scope.row.bilgDate) }}
            </template>
          </el-table-column>
          
          <!-- 发药人 -->
          <el-table-column
            prop="dismedOptName"
            label="发药人"
            align="center"
            width="100"
            show-overflow-tooltip
          />
          
          <!-- 发药时间 -->
          <el-table-column
            prop="dismedOptDate"
            label="发药时间"
            align="center"
            width="150"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ formatDateTime(scope.row.dismedOptDate) }}
            </template>
          </el-table-column>
          
          <!-- 收款时间 -->
          <el-table-column
            prop="costDate"
            label="收款时间"
            align="center"
            width="150"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ formatDateTime(scope.row.costDate) }}
            </template>
          </el-table-column>
          
          <!-- 退药金额 -->
          <el-table-column
            prop="reAmt"
            label="退药金额(元)"
            align="center"
            width="120"
          >
            <template slot-scope="scope">
              {{ formatCurrency(scope.row.reAmt) }}
            </template>
          </el-table-column>
          
          <!-- 操作列 -->
          <el-table-column
            label="操作"
            align="center"
            fixed="right"
            width="140"
          >
            <template slot-scope="scope">
              <div class="action-buttons">
                <!-- 处方详情按钮 - 所有状态都显示 -->
                <el-button 
                  type="primary" 
                  size="mini" 
                  @click="handleViewDetail(scope.row)"
                  plain
                >
                  详情
                </el-button>
                
                <!-- 退药按钮 - 只在state=3(已发药)时启用，否则禁用 -->
                <template v-if="scope.row.state === 3">
                  <el-button 
                    type="warning" 
                    size="mini" 
                    icon="el-icon-export"
                    @click="handleRefund(scope.row)"
                    plain
                  >
                    退药
                  </el-button>
                </template>
                <template v-else>
                  <el-tooltip 
                    content="当完成'发药'后，可进行退药操作。" 
                    placement="top"
                  >
                    <el-button 
                      type="warning" 
                      size="mini" 
                      icon="el-icon-export"
                      :disabled="true"
                      plain
                    >
                      退药
                    </el-button>
                  </el-tooltip>
                </template>
              </div>
            </template>
          </el-table-column>
        </el-table>
        
        <!-- 分页 -->
        <div class="pagination-container left-pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            small
          />
        </div>
      </div>
    </div>
    
    <!-- 处方详情模态框 -->
    <el-dialog 
      :title="currentDetail.name + ' ' + currentDetail.rxNo + ' 的处方详情'" 
      :visible.sync="detailDialogVisible" 
      width="80%" 
      top="5vh"
      custom-class="custom-dialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="detail-content">
        <!-- 顶部信息区域 -->
        <div class="detail-info">
          <el-descriptions :column="4" size="small" border>
            <el-descriptions-item label="患者姓名">
              <el-tag size="small">{{ currentDetail.name || '-' }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="性别">
              <div class="gender-display">
                <i :class="currentDetail.sex === 1 ? 'el-icon-male male-icon' : 'el-icon-female female-icon'"></i>
                <span :class="currentDetail.sex === 1 ? 'male-text' : 'female-text'">
                  {{ currentDetail.sex === 1 ? '男' : '女' }}
                </span>
              </div>
            </el-descriptions-item>
            <el-descriptions-item label="年龄">
              <el-tag size="small">{{ (currentDetail.age || 0) + '岁' }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="处方类别">
              <el-tag size="small">{{ currentDetail.rxName || '-' }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="处方状态">
              <el-tag
                :type="getStatusType(currentDetail.state)"
                size="small"
              >
                {{ getStatusText(currentDetail.state) }}
              </el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="处方金额">
              <el-tag size="small" type="danger">{{ formatCurrency(currentDetail.saleAmt) }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="处方科室">
              <el-tag size="small">{{ currentDetail.bilgDeptId || '-' }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="处方医生">
              <el-tag size="small">{{ currentDetail.bilgDrId || '-' }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="划价方式">
              <span>{{ getPricingTypeText(currentDetail.pricingType) }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="皮试处方">
              <span>{{ currentDetail.skintstRx === 1 ? '是' : '否' }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="划价人">
              <span>{{ currentDetail.bilgOptId || '-' }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="划价时间">
              <span>{{ formatDateTime(currentDetail.bilgDate) }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="发药人">
              <span>{{ currentDetail.dismedOptId || '-' }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="发药时间">
              <span>{{ formatDateTime(currentDetail.dismedOptDate) }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="收款时间">
              <span>{{ formatDateTime(currentDetail.costDate) }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="已退金额">
              <span>{{ formatCurrency(currentDetail.saleAmt) }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="退药标识">
              <el-tag :type="currentDetail.retFlag === 1 ? 'danger' : 'info'" size="small">
                {{ currentDetail.retFlag === 1 ? '已退药' : '未退药' }}
              </el-tag>
            </el-descriptions-item>
          </el-descriptions>
        </div>

        <!-- 处方药品明细表格区域 -->
        <div class="detail-table-container" v-if="detailDrugList.length > 0">
          <div class="table-title">处方药品明细</div>
          <el-table :data="detailDrugList" border highlight-current-row class="detail-table">
            <el-table-column label="序号" fixed="left" type="index" width="60" align="center"></el-table-column>
			
			<!-- 操作列 、 生产批次号 -->
			<el-table-column 
			  label="生产批次号" 
			  width="120"
			  fixed="left"
			  align="left"
			>
			  <template slot-scope="{ row, $index }">
			    <div class="action-column">
			      <span > {{ (row.manuLotnum) }}</span>
			    </div>
			  </template>
			</el-table-column>
            <el-table-column prop="name" label="药品名称" width="150" show-overflow-tooltip></el-table-column>
            <el-table-column prop="drugSpec" label="规格" width="120" show-overflow-tooltip></el-table-column>
            <el-table-column prop="cnt" label="数量" width="80" align="center"></el-table-column>
            <el-table-column prop="unt" label="单位" width="80" align="center"></el-table-column>
            <el-table-column prop="salePric" label="单价" width="100" align="right">
              <template slot-scope="{ row }">
                <span>{{ formatCurrency(row.salePric) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="saleAmt" label="金额" width="100" align="right">
              <template slot-scope="{ row }">
                <span>{{ formatCurrency(row.saleAmt) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="usage" label="用法" width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="usedFrquId" label="频次" width="80" align="center"></el-table-column>
            <el-table-column prop="prdCnt" label="周期次数" width="100" align="center"></el-table-column>
            <el-table-column prop="prdDays" label="周期天数" width="80" align="center"></el-table-column>
            <el-table-column prop="prodentpName" label="生产厂家" width="150" show-overflow-tooltip></el-table-column>
          </el-table>
        </div>
        
        <!-- 无药品明细提示 -->
        <div class="no-data" v-else>
          <el-empty description="暂无药品明细数据"></el-empty>
        </div>
      </div>
      
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="detailDialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
    
    <!-- 退药模态框 -->
    <el-dialog 
      :title="addForm.name + ' ' + addForm.rxNo + ' 的处方退药'" 
      :visible.sync="refundDialogVisible" 
      width="80%" 
      top="5vh"
      custom-class="custom-dialog refund-dialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="refund-content">
        <!-- 顶部信息区域 -->
        <div class="refund-info">
          <el-descriptions 
            :column="4" 
            size="small" 
            border
            :title="'药房:' + addForm.bilgDeptName"
          >
            <template slot="title">
              <div class="title-with-select">
                <div class="refund-reason-select">
                  <span class="reason-label">退药原因：</span>
                  <el-select 
                    v-model="addForm.refundReason" 
                    placeholder="请选择退药原因" 
                    size="mini"
                    filterable 
                    allow-create 
                    clearable 
                    class="reason-select"
                  >
                    <el-option v-for="item in refundReasons" :key="item.id" :label="item.value" :value="item.value"></el-option>
                  </el-select>
                </div>
				<div class="refund-reason-select" style="margin-left: 12px;">
				  <span class="reason-label">备注说明：</span>
				  <el-input
				    type="textarea" 
				    :rows="1" 
					maxlength="10"
				    v-model="addForm.remark" 
				    placeholder="请输入备注"
				    size="mini" 
				  ></el-input>
				</div>
              </div>
            </template>
            
            <el-descriptions-item label="患者姓名">
              <el-tag size="small">{{ addForm.name || '古老板' }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="性别">
              <div class="gender-display">
                <i :class="addForm.sex === 1 ? 'el-icon-male male-icon' : 'el-icon-female female-icon'"></i>
                <span :class="addForm.sex === 1 ? 'male-text' : 'female-text'">
                  {{ addForm.sex === 1 ? '男' : '女' }}
                </span>
              </div>
            </el-descriptions-item>
            <el-descriptions-item label="年龄">
              <el-tag size="small">{{ addForm.age + '岁' || '28岁' }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="处方编号">
              <el-tag size="small">{{ addForm.rxNo || 'JZ000000001' }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="处方类别">
              <el-tag size="small">{{ addForm.rxName || '急诊' }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="处方金额">
              <el-tag size="small" type="danger">{{ formatCurrency(addForm.saleAmt) }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="处方科室">
              <el-tag size="small">{{ addForm.bilgDeptName || '九阵门诊' }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="处方医生">
              <el-tag size="small">{{ addForm.patientName || '九阵管理员' }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="划价方式">
              <span>{{ pricingTypeMap[addForm.pricingType] || '' }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="处方诊断">
              <el-tag size="small">{{ addForm.westernDiagnos || '九阵管理员' }}</el-tag>
            </el-descriptions-item>
          </el-descriptions>
        </div>

        <!-- 处方退药明细表区域 -->
        <div class="refund-detail-container">
          <div class="refund-detail-content">
            <!-- 左侧药品列表 -->
            <div class="left-drug-list">
              <div class="drug-list-header">
                <span class="drug-list-title">处方退药明细表</span>
                <el-button 
                  type="danger" 
                  size="mini" 
                  plain 
                  @click="refundAll"
                  :loading="loading"
                  class="refund-all-btn"
                >
                  全退
                </el-button>
              </div>
              <div class="drug-list-content">
                <div 
                  v-for="(item, index) in leftDrugList" 
                  :key="index"
                  class="drug-list-item"
                  @dblclick="addToRightTable(item)"
                  :class="{ 'selected': isItemInRightTable(item) }"
                >
                  <div class="drug-avatar">
                    {{ getFirstChar(item.name) }}
                  </div>
                  <div class="drug-info">
                    <div class="drug-name">{{ item.name | truncate(8) }}</div>
                    <div class="drug-spec" v-if="item.drugSpec" :title="item.drugSpec">
                      {{ item.drugSpec | truncate(6) }}
                    </div>
                  </div>
                  <div class="drug-right-info">
                    <div class="drug-cnt">{{ item.cnt }}{{ item.unt }}</div>
                    <div class="drug-amount">{{ formatCurrencyWithSeparator(item.saleAmt) }}</div>
                  </div>
                </div>
              </div>
            </div>
            
            <!-- 右侧退药明细表 -->
            <div class="right-refund-table">
              <div class="table-header">退药明细</div>
              <div class="table-container">
                <el-table 
                  :data="rightTableData" 
                  border 
                  highlight-current-row 
                  class="refund-detail-table"
                  size="mini"
                >
                  <el-table-column 
                    label="药品名称" 
                    width="120"
                    show-overflow-tooltip
                  >
                    <template slot-scope="{ row }">
                      <span>{{ row.name }}</span>
                    </template>
                  </el-table-column>
                  
                  <el-table-column 
                    prop="drugSpec" 
                    label="药品规格" 
                    width="140"
                  >
                    <template slot-scope="{ row }">
                      <el-tooltip 
                        :content="row.drugSpec || '无规格'" 
                        placement="top"
                        v-if="row.drugSpec && row.drugSpec.length > 8"
                      >
                        <span>{{ row.drugSpec | truncate(8) }}</span>
                      </el-tooltip>
                      <span v-else>{{ row.drugSpec || '-' }}</span>
                    </template>
                  </el-table-column>
                  
                  <el-table-column 
                    label="待退数" 
                    width="100"
                    align="center"
                  >
                    <template slot-scope="{ row, $index }">
                      <!-- 编辑状态：显示输入框 -->
                      <el-input 
                        v-if="row.editing"
                        v-model.number="row.tempRetnCnt" 
                        size="mini"
                        @input="handleRetnCntInput(row, $index)"
                        class="retn-cnt-input"
                        placeholder="请输入"
                        :max="row.cnt"
                        :min="1"
                      ></el-input>
                      <!-- 锁定状态：显示文本 -->
                      <span v-else>
                        {{ row.retnCnt || 0 }}
                      </span>
                    </template>
                  </el-table-column>
                  
                  <el-table-column 
                    label="处方数量" 
                    width="100"
                    align="center"
                  >
                    <template slot-scope="{ row }">
                      <span>{{ row.cnt }}{{ row.unt }}</span>
                    </template>
                  </el-table-column>
                  
                  <el-table-column 
                    label="处方药单位" 
                    width="100"
                    align="center"
                  >
                    <template slot-scope="{ row }">
                      <span>{{ row.purcType === 1 ? '最小单位' : '包装单位' }}</span>
                    </template>
                  </el-table-column>
                  
                  <el-table-column 
                    label="药售单价" 
                    width="100"
                    align="right"
                  >
                    <template slot-scope="{ row }">
                      <span>{{ formatCurrencyWithSeparator(row.salePric) }}</span>
                    </template>
                  </el-table-column>
                  
                  <el-table-column 
                    label="药售总价" 
                    width="100"
                    align="right"
                  >
                    <template slot-scope="{ row }">
                      <span>{{ formatCurrencyWithSeparator(row.saleAmt) }}</span>
                    </template>
                  </el-table-column>
                  
                  <el-table-column 
                    label="批次号" 
                    width="100"
                    align="center"
                  >
                    <template slot-scope="{ row }">
                      <span>{{ row.manuLotnum || '-' }}</span>
                    </template>
                  </el-table-column>
                  
                  <el-table-column 
                    label="生产厂家" 
                    width="140"
                    show-overflow-tooltip
                  >
                    <template slot-scope="{ row }">
                      <span>{{ row.prodentpName || '-' }}</span>
                    </template>
                  </el-table-column>
                  
                  <!-- 操作列 -->
                  <el-table-column 
                    label="操作" 
                    width="160"
                    fixed="right"
                    align="center"
                  >
                    <template slot-scope="{ row, $index }">
                      <div class="action-column">
                        <!-- 差异数显示优化 -->
                        <el-tooltip 
                          :content="'差异金额: ' + formatCurrencyWithSeparator(row.diffAmount)" 
                          placement="top"
                          v-if="row.diffAmount !== null && row.diffAmount !== undefined && Math.abs(row.diffAmount).toString().length > 8"
                        >
                          <span 
                            class="diff-amount"
                            :class="{ 
                              'negative': row.diffAmount < 0,
                              'positive': row.diffAmount >= 0
                            }"
                          >
                            差异: {{ formatTruncatedNumber(row.diffAmount) }}
                          </span>
                        </el-tooltip>
                        <span 
                          v-else
                          class="diff-amount"
                          :class="{ 
                            'negative': row.diffAmount < 0,
                            'positive': row.diffAmount >= 0
                          }"
                        >
                          差异: {{ formatCurrencyWithSeparator(row.diffAmount) }}
                        </span>
                        <el-button 
                          v-if="!row.editing && row.retnCnt > 0"
                          type="text" 
                          size="mini"
                          @click="editItem(row, $index)"
                        >
                          修改
                        </el-button>
                        <el-button 
                          type="text" 
                          size="mini"
                          @click="removeItem($index)"
                          style="color: #F56C6C;"
                        >
                          移除
                        </el-button>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 底部固定操作区域 -->
      <div class="refund-footer-fixed">
        <div class="footer-left-info">
          <div class="info-row">
            <div class="info-item">
              <span class="info-label">处方总额：</span>
              <span class="info-value-money">{{ formatCurrencyWithSeparator(prescriptionDetail.saleAmt || 0) }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">处方药：</span>
              <span class="info-value">{{ leftDrugList.length }}种</span>
            </div>
            <div class="info-item">
              <span class="info-label">当前待退处方：</span>
              <span class="info-value">{{ rightTableData.length }}种</span>
            </div>
            <div class="info-item">
              <span class="info-label">当前待退处方总额：</span>
              <span class="info-value-money">{{ formatCurrencyWithSeparator(refundTotalAmount) }}</span>
            </div>
          </div>
        </div>
        <div class="refund-actions">
          <el-button 
            :loading="loading" 
            type="primary" 
            size="small" 
            plain 
            @click="handleBatchRefund"
            :disabled="!isConfirmButtonEnabled" 
            class="footer-btn"
          >
            确认退药
          </el-button>
          <el-button size="small" @click="refundDialogVisible = false">取消</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { rxmainZYPage, getZYRefundDrug, tyZYSave } from "@/api/MedicenHouse/WesternGive.js"

export default {
  name: 'DisposalStatistics',
  filters: {
    truncate(value, length) {
      if (!value) return ''
      if (value.length <= length) return value
      return value.substring(0, length) + '...'
    }
  },
  data() {
    return {
      // 筛选条件
      filters: {
        rxNo: '',
        filterState: '',
        dateRange: []
      },
      // 表格数据
      tableData: [],
      loading: false,
      
      // 分页
      pageNum: 1,
      pageSize: 20,
      total: 0,
      
      // 表格最大高度
      tableMaxHeight: 'calc(100vh - 280px)',
      
      // 详情模态框相关
      detailDialogVisible: false,
      currentDetail: {},
      detailDrugList: [],
      
      // 退药模态框相关
      refundDialogVisible: false,
      // 左侧药品列表数据
      leftDrugList: [],
      // 右侧退药明细表数据
      rightTableData: [],
      refundTotalAmount: 0,
      isConfirmButtonEnabled: false,
      
      // 处方详情数据
      prescriptionDetail: {},
      
      // 退药表单
      addForm: {
        "age": 0,
        "bilgDeptId": 0,
        "bilgDeptName": "",
        "id": 0,
        "name": "",
        "phayId": 0,
        "pricingType": 0,
        "remark": "",
        "rxName": "",
        "rxNo": 0,
        "saleAmt": 0,
        "sex": 0,
        "refundReason": "",
        "westernDiagnos": "",
        "patientName": "",
        "refundList": []
      },
      
      // 退药原因选项
      refundReasons: [
        { value: '患者过敏', id: 1 },
        { value: '药品不良反应', id: 2 },
        { value: '医生更改处方', id: 3 },
        { value: '患者病情变化', id: 4 },
        { value: '药品质量问题', id: 5 },
        { value: '患者拒绝用药', id: 6 },
        { value: '用药剂量错误', id: 7 },
        { value: '药品过期', id: 8 },
        { value: '药品包装破损', id: 9 },
        { value: '其他原因', id: 10 }
      ],
      
      // 状态映射
      statusMap: {
        0: '草稿',
        1: '已收费',
        2: '已配药',
        3: '已发药',
        4: '待退费',
        5: '已退药',
        6: '已作废',
        7: '已退费'
      },
      
      // 划价方式映射
      pricingTypeMap: {
        1: '医嘱划价',
        2: '手工划价',
        3: '互联网划价',
      },
      
      // 状态标签类型
      statusTypeMap: {
        0: 'info',      // 草稿
        1: 'primary',   // 已收费
        2: 'primary',   // 已配药
        3: 'success',   // 已发药
        4: 'primary',   // 待退费
        5: 'warning',   // 已退药
        6: 'danger',    // 已作废
        7: 'warning'       // 已退费
      }
    }
  },
  mounted() {
    this.updateTableHeight();
    this.setDefaultDateRange();
    this.loadData();
    window.addEventListener('resize', this.updateTableHeight)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateTableHeight)
  },
  methods: {
    // 更新表格高度
    updateTableHeight() {
      const headerHeight = 60
      const filterHeight = 80
      const paginationHeight = 60
      const padding = 40
      this.tableMaxHeight = `calc(100vh - ${headerHeight + filterHeight + paginationHeight + padding}px)`
    },
    
    // 设置默认日期范围
    setDefaultDateRange() {
      const now = new Date();
      
      // 设置开始时间为当天00:00:00
      const startDate = new Date(now);
      startDate.setHours(0, 0, 0, 0);
      const startDateStr = this.formatDate(startDate);
      
      // 设置结束时间为当天23:59:59
      const endDate = new Date(now);
      endDate.setHours(23, 59, 59, 999);
      const endDateStr = this.formatDate(endDate);
      
      this.filters.dateRange = [startDateStr, endDateStr];
    },
    
    // 格式化日期
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    
    // 格式化货币金额（带千位分隔符）
    formatCurrency(value) {
      if (value === null || value === undefined || value === '') {
        return '￥0'
      }
      
      // 转换为数字
      const num = Number(value)
      if (isNaN(num)) {
        return '￥0'
      }
      
      // 获取小数部分
      const parts = num.toString().split('.')
      let integerPart = parts[0]
      const decimalPart = parts.length > 1 ? '.' + parts[1] : ''
      
      // 添加千位分隔符
      integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      
      return `￥${integerPart}${decimalPart}`
    },
    
    // 格式化货币金额（带千位分隔符，用于模态框）
    formatCurrencyWithSeparator(value) {
      if (value === null || value === undefined || value === '') {
        return '￥0'
      }
      
      // 转换为数字
      const num = Number(value)
      if (isNaN(num)) {
        return '￥0'
      }
      
      // 获取小数部分
      const parts = num.toString().split('.')
      let integerPart = parts[0]
      const decimalPart = parts.length > 1 ? '.' + parts[1] : ''
      
      // 添加千位分隔符
      integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      
      return `￥${integerPart}${decimalPart}`
    },
    
    // 格式化截断数字
    formatTruncatedNumber(value) {
      if (value === null || value === undefined || value === '') {
        return '￥0';
      }
      
      const num = Number(value);
      if (isNaN(num)) {
        return '￥0';
      }
      
      const formatted = this.formatCurrencyWithSeparator(value);
      if (formatted.length <= 8) {
        return formatted;
      }
      
      // 截断显示
      return formatted.substring(0, 8) + '...';
    },
    
    // 格式化数字（保留2位小数）
    formatNumber(value) {
      if (value === null || value === undefined || value === '') {
        return '0.00'
      }
      
      const num = Number(value)
      if (isNaN(num)) {
        return '0.00'
      }
      
      return num.toFixed(2)
    },
    
    // 格式化日期时间
    formatDateTime(dateTime) {
      if (!dateTime) return '-';
      return dateTime;
    },
    
    // 获取状态文本
    getStatusText(state) {
      return this.statusMap[state] || '未知状态';
    },
    
    // 获取状态标签类型
    getStatusType(state) {
      return this.statusTypeMap[state] || 'info';
    },
    
    // 获取划价方式文本
    getPricingTypeText(type) {
      return this.pricingTypeMap[type] || '未知';
    },
    
    // 获取状态按钮显示文本
    getStateButtonText() {
      if (this.filters.filterState === '') {
        return '全部';
      }
      return this.getStatusText(this.filters.filterState);
    },
    
    // 获取药品名称的第一个字符
    getFirstChar(name) {
      if (!name || typeof name !== 'string') return '药';
      return name.charAt(0);
    },
    
    // 判断药品是否已在右侧表格中
    isItemInRightTable(item) {
      return this.rightTableData.some(rightItem => rightItem.id === item.id);
    },
    
    // 状态下拉菜单选择
    handleStateCommand(command) {
      this.filters.filterState = command;
      this.handleSearch();
    },
    
    // 查询
    async loadData() {
      try {
        this.loading = true;
        
        const params = {
          condis: this.filters.rxNo,
          sendStartTime: this.filters.dateRange[0] || '',
          sendEndTime: this.filters.dateRange[1] || '',
          state: this.filters.filterState === '' ? '' : this.filters.filterState,
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          bilgDrId: '',
          bilgDeptId: ''
        };
        
        const res = await rxmainZYPage(params);
        
        if (res.code === 200) {
          this.tableData = res.data.content || [];
          this.total = res.data.totalSize || 0;
        } else {
          this.$message.error(res.message || '获取数据失败');
          this.tableData = [];
          this.total = 0;
        }
      } catch (error) {
        console.error('查询失败:', error);
        this.$message.error('查询失败');
        this.tableData = [];
        this.total = 0;
      } finally {
        this.loading = false;
      }
    },
    
    // 搜索
    handleSearch() {
      this.pageNum = 1;
      this.loadData();
    },
    
    // 重置
    handleReset() {
      this.filters = {
        rxNo: '',
        filterState: '',
        dateRange: []
      };
      this.setDefaultDateRange();
      this.pageNum = 1;
      this.pageSize = 20;
      this.loadData();
    },
    
    // 导出
    handleExport() {
      this.$message.success('导出功能开发中')
    },
    
    // 分页大小改变
    handleSizeChange(val) {
      this.pageSize = val
      this.pageNum = 1
      this.loadData()
    },
    
    // 当前页改变
    handleCurrentChange(val) {
      this.pageNum = val
      this.loadData()
    },
    
    // 查看详情
    async handleViewDetail(row) {
      try {
        this.loading = true;
        
        // 这里调用获取处方详情的接口
        const res = await getZYRefundDrug({ id: row.id });
        
        if (res.code === 200) {
          this.currentDetail = res.data.prescription || row;
          this.detailDrugList = res.data.refundList || [];
          this.detailDialogVisible = true;
        } else {
          this.$message.error(res.message || '获取处方详情失败');
        }
      } catch (error) {
        console.error('获取处方详情失败:', error);
        this.$message.error('获取处方详情失败');
        // 如果接口失败，至少显示基本信息
        this.currentDetail = row;
        this.detailDrugList = [];
        this.detailDialogVisible = true;
      } finally {
        this.loading = false;
      }
    },
    
    // 表格行类名
    tableRowClassName({ row }) {
      if (row.state === 3) {
        return 'warning-row';
      }
      return '';
    },
    
    // 退药操作
    async handleRefund(row) {
      try {
        this.loading = true;
        
        // 重置数据
        this.leftDrugList = [];
        this.rightTableData = [];
        
        const res = await getZYRefundDrug({ id: row.id });

        if (res.code === 200) {
          // 保存处方详情数据
          this.prescriptionDetail = res.data;

          // 设置左侧药品列表数据
          this.leftDrugList = (res.data.refundList || []).map(item => ({
            ...item,
            detailId: item.id, // 保存明细ID
            retnCnt: 0, // 初始待退数量为0
            retnAmt: 0, // 初始待退金额为0
            diffAmount: 0, // 初始差异金额
            purcType: item.purcType || 1, // 默认最小单位
            editing: false, // 编辑状态
            tempRetnCnt: 0 // 临时待退数量
          }));

          // 设置表单数据
          this.addForm = {
            ...res.data,
          };

          this.refundDialogVisible = true;
        } else {
          this.$message.error(res.message || '获取退药详情失败');
        }
      } catch (error) {
        console.error('退药详情获取失败:', error);
        this.$message.error('获取退药详情失败');
      } finally {
        this.loading = false;
      }
    },
    
    // 添加药品到右侧表格
    addToRightTable(item) {
      // 检查是否已存在
      if (this.isItemInRightTable(item)) {
        this.$message.warning('该药品已存在于退药明细中');
        return;
      }
      
      // 创建新对象，避免引用问题
      const newItem = {
        ...item,
        id: item.id || item.detailId,
        retnCnt: 0,
        diffAmount: item.saleAmt || 0,
        editing: true, // 默认进入编辑状态
        tempRetnCnt: 0, // 临时待退数量
        timer: null // 定时器
      };
      
      this.rightTableData.push(newItem);
      this.calculateRefundTotal();
      this.updateConfirmButtonState();
    },
    
    // 全退操作
    refundAll() {
      if (this.leftDrugList.length === 0) {
        this.$message.warning('没有可退药的药品');
        return;
      }
      
      // 清空右侧表格
      this.rightTableData = [];
      
      // 将左侧所有药品添加到右侧表格，并设置待退数量为可退数量
      this.leftDrugList.forEach(item => {
        const newItem = {
          ...item,
          id: item.id || item.detailId,
          retnCnt: item.cnt || 0, // 设置待退数量为可退数量
          diffAmount: 0, // 初始差异金额为0
          editing: false, // 锁定状态
          tempRetnCnt: item.cnt || 0, // 临时待退数量
          timer: null
        };
        
        // 计算差异金额
        this.calculateDiffAmount(newItem);
        this.rightTableData.push(newItem);
      });
      
      this.calculateRefundTotal();
      this.updateConfirmButtonState();
      this.$message.success('已将所有药品添加到退药明细');
    },
    
    // 计算差异金额
    calculateDiffAmount(item) {
      const saleAmt = Number(item.saleAmt) || 0;
      const salePric = Number(item.salePric) || 0;
      const retnCnt = Number(item.retnCnt) || 0;
      
      // 差异金额 = 药售总价 - (待退数量 * 药售单价)
      item.diffAmount = saleAmt - (retnCnt * salePric);
      
      return item.diffAmount;
    },
    
    // 处理待退数量输入
    handleRetnCntInput(row, index) {
      // 1. 首先清除之前的定时器
      if (row.timer) {
        clearTimeout(row.timer);
        row.timer = null;
      }
      
      // 2. 限制只能输入数字
      let inputValue = row.tempRetnCnt.toString();
      inputValue = inputValue.replace(/[^\d]/g, '');
      
      // 3. 限制不能以0开头
      if (inputValue === '0') {
        inputValue = '';
      }
      
      row.tempRetnCnt = inputValue;
      
      // 4. 实时计算差异金额（基于当前输入值）
      const tempRetnCnt = Number(row.tempRetnCnt) || 0;
      const saleAmt = Number(row.saleAmt) || 0;
      const salePric = Number(row.salePric) || 0;
      const tempDiffAmount = saleAmt - (tempRetnCnt * salePric);
      
      // 5. 立即更新差异金额显示
      row.diffAmount = tempDiffAmount;
      
      // 6. 设置新的定时器，2.88秒后锁定行
      row.timer = setTimeout(() => {
        this.lockRowAfterTimer(row, index);
      }, 500);
      
      // 7. 实时计算退药总金额
      this.calculateRefundTotal();
      
      // 8. 更新确认按钮状态
      this.updateConfirmButtonState();
    },
    
    // 定时器结束后锁定行
    lockRowAfterTimer(row, index) {
      let tempRetnCnt = Number(row.tempRetnCnt) || 0;
      const cnt = Number(row.cnt) || 0;
      
      // 校验输入值
      if (tempRetnCnt <= 0) {
        this.$message.error('待退数必须大于0');
        row.tempRetnCnt = '';
        row.editing = true;
        return;
      }
      
      if (!Number.isInteger(tempRetnCnt)) {
        this.$message.error('待退数必须为正整数');
        row.tempRetnCnt = Math.floor(tempRetnCnt);
        tempRetnCnt = Math.floor(tempRetnCnt);
      }
      
      if (tempRetnCnt > cnt) {
        this.$message.error(`待退数不能超过处方总数 ${cnt}`);
        row.tempRetnCnt = cnt;
        tempRetnCnt = cnt;
      }
      
      // 保存待退数
      row.retnCnt = tempRetnCnt;
      
      // 计算最终差异金额
      this.calculateDiffAmount(row);
      
      // 如果差异金额为负数，显示提示
      if (row.diffAmount < 0) {
        this.$message.warning(`药品 ${row.name} 的待退金额差异为负数，请检查输入`);
      }
      
      // 锁定行（退出编辑状态）
      row.editing = false;
      
      // 清除定时器
      if (row.timer) {
        clearTimeout(row.timer);
        row.timer = null;
      }
      
      // 计算退药总金额
      this.calculateRefundTotal();
      
      // 更新确认按钮状态
      this.updateConfirmButtonState();
    },
    
    // 计算退药总金额
    calculateRefundTotal() {
      if (!this.rightTableData || this.rightTableData.length === 0) {
        this.refundTotalAmount = 0;
        return 0;
      }

      const total = this.rightTableData.reduce((sum, row) => {
        const salePric = Number(row.salePric) || 0;
        const retnCnt = Number(row.retnCnt) || 0;
        const rowAmount = retnCnt * salePric;
        return sum + rowAmount;
      }, 0);

      this.refundTotalAmount = total;
      return this.refundTotalAmount;
    },
    
    // 编辑项目
    editItem(row, index) {
      row.editing = true;
      row.tempRetnCnt = row.retnCnt || '';
    },
    
    // 移除项目
    removeItem(index) {
      // 清除定时器
      if (this.rightTableData[index].timer) {
        clearTimeout(this.rightTableData[index].timer);
      }
      
      this.rightTableData.splice(index, 1);
      this.calculateRefundTotal();
      this.updateConfirmButtonState();
    },
    
    // 更新确认按钮状态
    updateConfirmButtonState() {
      if (!this.rightTableData || this.rightTableData.length === 0) {
        this.isConfirmButtonEnabled = false;
        return;
      }

      // 检查是否有数据，并且所有数据都填写了待退数量
      const hasValidRefund = this.rightTableData.some(item => {
        const retnCnt = Number(item.retnCnt) || 0;
        return retnCnt > 0;
      });

      // 检查是否有未完成编辑的行
      const hasEditingRow = this.rightTableData.some(item => item.editing === true);
      
      // 检查是否有差异金额为负数的行
      const hasNegativeDiff = this.rightTableData.some(item => {
        const diffAmount = Number(item.diffAmount) || 0;
        return diffAmount < 0;
      });
      
      this.isConfirmButtonEnabled = hasValidRefund && !hasEditingRow && !hasNegativeDiff;
    },
    
    // 确定退药
    async handleBatchRefund() {
      try {
        this.loading = true;

        // 验证数据
        const validRefundItems = this.rightTableData.filter(item => {
          const retnCnt = Number(item.retnCnt) || 0;
          return retnCnt > 0;
        });
        
        if (validRefundItems.length === 0) {
          this.$message.warning('请至少设置一条有效的待退数量');
          return;
        }

        const params = {
          id: this.addForm.id,
          list: validRefundItems.map(item => ({
            detailId: item.detailId || item.id,
            retnCnt: Number(item.retnCnt) || 0
          }))
        };

        if (!params.id) {
          this.$message.error('处方ID不能为空');
          return;
        }

        if (params.list.length === 0) {
          this.$message.error('没有可退药的药品项目');
          return;
        }

        const res = await tyZYSave(params);

        if (res.code === 200) {
          this.$message.success('退药成功');
          this.refundDialogVisible = false;
          this.loadData();
        } else {
          this.$message.error(res.message || '退药失败');
        }
      } catch (error) {
        console.error('退药出错:', error);
        this.$message.error('退药操作出错');
      } finally {
        this.loading = false;
      }
    },
  }
}
</script>

<style lang="less" scoped>
.disposal-statistics-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #f5f7fa;
  overflow: hidden;
  
  // 头部区域
  .header-section {
    padding: 16px 20px;
    background-color: #fff;
    border-bottom: 1px solid #e6e6e6;
    
    .title {
      font-size: 18px;
      font-weight: bold;
      color: #00405e;
      margin-bottom: 4px;
    }
    
    .sub-title {
      font-size: 14px;
      color: #666;
    }
  }
  
  // 筛选区域
  .filter-section {
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    margin-top: 8px;
    .filter-container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      
      .filter-left {
        display: flex;
        align-items: center;
        gap: 20px;
        
        .filter-item {
          display: flex;
          align-items: center;
          
          .filter-label {
            font-size: 12px;
            color: #606266;
            margin-right: 8px;
            white-space: nowrap;
          }
          
          .state-dropdown-btn {
            background: linear-gradient(135deg, #409EFF, #66b1ff);
            border: none;
            border-radius: 4px;
            padding: 7px 12px;
            font-size: 12px;
            min-width: 80px;
          }
        }
      }
      
      .filter-right {
        display: flex;
        gap: 8px;
      }
    }
  }
  
  // 表格区域
  .table-section {
    flex: 1;
    margin-top: 16px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    
    .table-container {
      flex: 1;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      
      .el-table {
        flex: 1;
        overflow: auto;
        
        // 状态为3的行样式
        ::v-deep .warning-row {
          background-color: #fdf6ec !important;
        }
        
        .action-buttons {
          display: flex;
          justify-content: space-around;
          align-items: center;
          
          .el-button {
            padding: 5px 8px;
            font-size: 12px;
          }
        }
        
        // 性别显示样式
        .gender-display {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 4px;
          
          .male-icon {
            color: #409EFF;
            font-size: 14px;
          }
          
          .female-icon {
            color: #F56C6C;
            font-size: 14px;
          }
          
          .male-text {
            color: #409EFF;
            font-weight: 500;
          }
          
          .female-text {
            color: #F56C6C;
            font-weight: 500;
          }
        }
        
        // 病人姓名字段样式
        .patient-name-link {
          color: #409EFF;
          text-decoration: none;
          font-weight: bold;
          transition: color 0.3s;
          
          &:hover {
            color: #1a6be0;
            text-decoration: underline;
          }
        }
      }
      
      .pagination-container {
        padding: 16px 0;
        background-color: #fff;
        border-top: 1px solid #e6e6e6;
        
        &.left-pagination {
          display: flex;
          justify-content: flex-start;
          
          .el-pagination {
            margin: 0;
          }
        }
      }
    }
  }
}

// 处方药品明细表格文字大小
::v-deep .detail-table {
  font-size: 12px !important;
  
  .el-table__header th {
    font-size: 12px !important;
  }
  
  .el-table__body td {
    font-size: 12px !important;
  }
}

// 退药明细表格文字大小
::v-deep .refund-detail-table {
  font-size: 12px !important;
  
  .el-table__header th {
    font-size: 12px !important;
  }
  
  .el-table__body td {
    font-size: 12px !important;
  }
  
  .retn-cnt-input {
    .el-input__inner {
      font-size: 12px !important;
      height: 28px;
      line-height: 28px;
      text-align: center;
    }
  }
  
  .action-column {
    display: flex;
    align-items: center;
    justify-content: space-between;
    
    .diff-amount {
      font-size: 12px;
      color: #67C23A;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 80px;
      display: inline-block;
      
      &.negative {
        color: #F56C6C;
      }
      
      &.positive {
        color: #67C23A;
      }
    }
    
    .el-button {
      font-size: 12px;
      padding: 0 2px;
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .filter-container {
    flex-direction: column;
    gap: 16px;
    
    .filter-left {
      flex-wrap: wrap;
    }
    
    .filter-right {
      width: 100%;
      justify-content: center;
    }
  }
  
  .pagination-container {
    &.left-pagination {
      justify-content: center !important;
    }
  }
}
</style>

<style lang="less">
	// 自定义模态框样式
	.custom-dialog {
	  border-radius: 8px !important;
	  overflow: hidden;
	  
	  .el-dialog__header {
	    background: linear-gradient(135deg, #1a6be0 0%, #409EFF 100%) !important;
	    padding: 15px 20px;
	    border-radius: 8px 8px 0 0;
	    
	    .el-dialog__title {
	      color: white;
	      font-weight: 600;
	      font-size: 16px;
	    }
	    .el-dialog__headerbtn {
	      .el-dialog__close {
	        color: white;
	        font-size: 18px;
	        
	        &:hover {
	          color: #f0f0f0;
	        }
	      }
	    }
	  }
	  
	  .el-dialog__body {
	    // padding: 20px 20px 100px 20px; /* 底部留出更多空间给固定操作区域 */
	    // max-height: 70vh;
	    overflow-y: auto;
	  }
	  
	  .el-dialog__footer {
	    border-top: none;
	  }
	  
	  .detail-content{
		
		.detail-table-container{
			.table-title{
				padding: 12px 0;
				color: #5b5b5b;
				font-weight: bold;
				font-size: 16px;
			}
		}
	  }
	}
	
	// 退药模态框样式
	.refund-dialog {
	  .el-dialog {
	    width: 80% !important;
	    max-width: 1200px;
	  }
	  
	  .refund-content {
	    .refund-info {
	      margin-bottom: 20px;
	
	      .title-with-select {
	        display: flex;
	        justify-content: space-between;
	        align-items: center;
	        
	        .refund-reason-select {
	          display: flex;
	          align-items: center;
	          
	          .reason-label {
	            font-size: 12px;
	            color: #606266;
	            margin-right: 8px;
	            white-space: nowrap;
	          }
	          
	          .reason-select {
	            width: 200px;
	            
	            .el-input__inner {
	              height: 28px;
	              line-height: 28px;
	            }
	          }
	          
	          .remark-textarea {
	            width: 150px;
	            
	            .el-textarea__inner {
	              resize: none;
	              height: 28px;
	              line-height: 28px;
	            }
	          }
	        }
	      }
	
	      .gender-display {
	        display: flex;
	        align-items: center;
	        gap: 4px;
	
	        .male-icon {
	          color: #409EFF;
	        }
	
	        .female-icon {
	          color: #F56C6C;
	        }
	        
	        .male-text {
	          color: #409EFF;
	        }
	        
	        .female-text {
	          color: #F56C6C;
	        }
	      }
	    }
	    
	    // 处方退药明细表区域
	    .refund-detail-container {
	      margin-bottom: 20px;
	      border: 1px solid #ebeef5;
	      border-radius: 4px;
	      overflow: hidden;
	      
	      .refund-detail-content {
	        display: flex;
	        height: 400px;
	        
	        .left-drug-list {
	          width: 18%; /* 左侧宽度18% */
	          border-right: 1px solid #ebeef5;
	          display: flex;
	          flex-direction: column;
	          
	          .drug-list-header {
	            padding: 12px 16px;
	            border-bottom: 1px solid #ebeef5;
	            display: flex;
	            justify-content: space-between;
	            align-items: center;
	            
	            .drug-list-title {
	              font-size: 14px;
	              font-weight: 600;
	              color: #333;
	            }
	            
	            .refund-all-btn {
	              padding: 4px 8px;
	              font-size: 12px;
	            }
	          }
	          
	          .drug-list-content {
	            flex: 1;
	            overflow-y: auto;
	            max-height: 320px; /* 设置最大高度，确保滚动 */
	            scrollbar-width: thin;
	            scrollbar-color: #c1c1c1 #f5f5f5;
	            
	            &::-webkit-scrollbar {
	              width: 6px;
	            }
	            
	            &::-webkit-scrollbar-track {
	              background: #f5f5f5;
	              border-radius: 3px;
	            }
	            
	            &::-webkit-scrollbar-thumb {
	              background: #c1c1c1;
	              border-radius: 3px;
	            }
	            
	            &::-webkit-scrollbar-thumb:hover {
	              background: #a8a8a8;
	            }
	            
	            .drug-list-item {
	              padding: 12px 16px;
	              border-bottom: 1px solid #f0f0f0;
	              display: flex;
	              align-items: center;
	              cursor: pointer;
	              transition: background-color 0.3s;
	              
	              &:hover {
	                background-color: #f5f7fa;
	              }
	              
	              &.selected {
	                background-color: #f0f9ff;
	                border-left: 3px solid #409EFF;
	              }
	              
	              .drug-avatar {
	                width: 36px;
	                height: 36px;
	                border-radius: 50%;
	                background: linear-gradient(135deg, #409EFF, #66b1ff);
	                color: white;
	                display: flex;
	                align-items: center;
	                justify-content: center;
	                font-size: 16px;
	                font-weight: bold;
	                margin-right: 12px;
	                flex-shrink: 0;
	              }
	              
	              .drug-info {
	                flex: 1;
	                overflow: hidden;
	                
	                .drug-name {
	                  font-size: 13px;
	                  font-weight: 500;
	                  color: #333;
	                  margin-bottom: 2px;
	                  white-space: nowrap;
	                  overflow: hidden;
	                  text-overflow: ellipsis;
	                }
	                
	                .drug-spec {
	                  font-size: 11px;
	                  color: #666;
	                  margin-bottom: 4px;
	                  white-space: nowrap;
	                  overflow: hidden;
	                  text-overflow: ellipsis;
	                }
	              }
	              
	              .drug-right-info {
	                display: flex;
	                flex-direction: column;
	                align-items: flex-end;
	                margin-left: 8px;
	                
	                .drug-cnt {
	                  font-size: 12px;
	                  color: #409EFF;
	                  font-weight: 500;
	                  margin-bottom: 2px;
	                  white-space: nowrap;
	                }
	                
	                .drug-amount {
	                  font-size: 12px;
	                  color: #F56C6C;
	                  font-weight: 500;
	                  white-space: nowrap;
	                }
	              }
	            }
	          }
	        }
	        
	        .right-refund-table {
	          width: 82%; /* 右侧宽度82% */
	          display: flex;
	          flex-direction: column;
	          
	          .table-header {
	            padding: 12px 16px;
	            border-bottom: 1px solid #ebeef5;
	            font-size: 14px;
	            font-weight: 600;
	            color: #333;
	          }
	          
	          .table-container {
	            flex: 1;
	            overflow: auto;
	            
	            .refund-detail-table {
	              height: 100%;
	              
	              .el-table__body-wrapper {
	                max-height: 350px;
	                overflow-y: auto;
	              }
	            }
	          }
	        }
	      }
	    }
	    
	    .no-data {
	      padding: 40px 0;
	      text-align: center;
	      color: #909399;
	    }
	  }
	  
	  // 底部固定操作区域
	  .refund-footer-fixed {
	    position: absolute;
	    bottom: 0;
	    left: 0;
	    right: 0;
	    background: white;
	    padding: 15px 20px;
	    border-top: 1px solid #ebeef5;
	    display: flex;
	    justify-content: space-between;
	    align-items: center;
	    z-index: 1000;
	
	    .footer-left-info {
	      flex: 1;
	      
	      .info-row {
	        display: flex;
	        align-items: center;
	        flex-wrap: wrap;
	        gap: 20px;
	        
	        .info-item {
	          display: flex;
	          align-items: center;
	          
	          .info-label {
	            font-size: 14px;
	            color: #606266;
				font-weight: 600;
	            white-space: nowrap;
	          }
	          
	          .info-value {
	            font-size: 14px;
	            font-weight: 600;
	            color: #00557f;
	            margin-left: 4px;
	          }
			  .info-value-money{
				font-size: 14px;
				font-weight: 600;
				color: #ac0000;
				margin-left: 4px;
			  }
	        }
	      }
	    }
	
	    .refund-actions {
	      display: flex;
	      gap: 8px;
	    }
	  }
	}
	
	// 响应式设计
	@media (max-width: 1200px) {
	  .disposal-statistics-container {
	    .detail-container {
	      flex-direction: column;
	      height: auto;
	      
	      .detail-left {
	        width: 100%;
	        margin-bottom: 20px;
	      }
	    }
	    
	    .refund-dialog {
	      .el-dialog {
	        width: 90% !important;
	      }
	      
	      .refund-footer-fixed {
	        flex-direction: column;
	        align-items: flex-start;
	        gap: 10px;
	        
	        .footer-left-info {
	          .info-row {
	            gap: 10px;
	          }
	        }
	      }
	    }
	  }
	}
</style>